import {
    ADDON_SERVICES_ERROR_ACTION_TYPE,
    ADDON_SERVICES_FETCH_ACTION_TYPE,
    ADDON_SERVICES_FETCH_SUCCESS_ACTION_TYPE,
    ADDON_SERVICES_RESET_ACTION_TYPE,
    AddonServicesAction
} from 'actions/addonServices/AddonServicesActionsTypes';
import { AddonServicesState, AddonServiceStatus } from 'reducers/addonServices/AddonServicesState';
import { Reducer } from 'redux';

const initialState: AddonServicesState = {
    addonServices: [],
    status: AddonServiceStatus.Initial,
    loading: true
};

export const addonServicesReducer: Reducer<AddonServicesState, AddonServicesAction> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case ADDON_SERVICES_RESET_ACTION_TYPE:
            return {
                ...initialState
            };
        case ADDON_SERVICES_FETCH_ACTION_TYPE:
            return {
                ...state,
                loading: true,
                status: AddonServiceStatus.Fetching
            };
        case ADDON_SERVICES_FETCH_SUCCESS_ACTION_TYPE:
            return {
                ...state,
                loading: false,
                status: AddonServiceStatus.FetchSuccess,
                addonServices: action.payload.addonServices
            };
        case ADDON_SERVICES_ERROR_ACTION_TYPE:
            return {
                ...state,
                loading: false,
                status: AddonServiceStatus.Error
            };
        default:
            return state;
    }
};
